module.exports = __webpack_public_path__ + "static/media/logo1.253da155.png";